import { useState } from 'react';
import { FaSearch, FaUser } from 'react-icons/fa';
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import PatientDoctorDocumentsTable from '../DoctorComponent/PatientDoctorDocumentsTable';

const ClinicPatientDocumentsSearch = () => {
    const [idNumberInput, setIdNumberInput] = useState('');
    const [searching, setSearching] = useState(false);
    const [selectedPatient, setSelectedPatient] = useState(null);

    const handleSearch = async (event) => {
        event?.preventDefault();

        const idNumber = idNumberInput.trim();
        if (!idNumber) {
            alertaGeneral({
                titulo: 'Documento requerido',
                messageHtml: 'Escribe la cédula del paciente para consultar sus documentos.',
                isWarning: true,
            });
            return;
        }

        setSearching(true);
        setSelectedPatient(null);

        try {
            const response = await apiClient.get(
                `/api/clinic/patient-by-id-number/${encodeURIComponent(idNumber)}`
            );
            setSelectedPatient(response.data);
        } catch (error) {
            const message = error.response?.data?.message || 'No se pudo buscar el paciente. Inténtalo de nuevo.';
            alertaGeneral({
                titulo: 'Paciente no encontrado',
                messageHtml: message,
                isError: true,
            });
        } finally {
            setSearching(false);
        }
    };

    const handleClear = () => {
        setIdNumberInput('');
        setSelectedPatient(null);
    };

    return (
        <div className="space-y-6 w-full">
            <div className="bg-white rounded-2xl shadow-md border border-slate-100 p-5 md:p-6">
                <h1 className="text-lg md:text-xl font-bold text-[#205087] mb-1">Documentos médicos de pacientes</h1>
                <p className="text-sm text-slate-600 mb-5">
                    Consulte los documentos clínicos de cualquier paciente registrado en la plataforma.
                </p>

                <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-3">
                    <label className="flex-1">
                        <span className="sr-only">Cédula del paciente</span>
                        <input
                            type="text"
                            inputMode="numeric"
                            value={idNumberInput}
                            onChange={(e) => setIdNumberInput(e.target.value)}
                            placeholder="Escribe la cédula del paciente"
                            className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#1f94c2] focus:border-[#1f94c2]"
                            disabled={searching}
                        />
                    </label>
                    <div className="flex gap-2 shrink-0">
                        <button
                            type="submit"
                            disabled={searching}
                            className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#1f94c2] px-5 py-3 text-sm font-semibold text-white hover:bg-[#1a7fa8] disabled:opacity-60 transition-colors"
                        >
                            <FaSearch className="w-4 h-4" />
                            {searching ? 'Buscando...' : 'Buscar'}
                        </button>
                        {selectedPatient && (
                            <button
                                type="button"
                                onClick={handleClear}
                                className="rounded-xl border border-slate-300 px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors"
                            >
                                Limpiar
                            </button>
                        )}
                    </div>
                </form>
            </div>

            {selectedPatient && (
                <div className="space-y-4">
                    <div className="flex items-start gap-3 rounded-xl bg-[#ecf8fd] border border-[#1f94c2]/20 px-4 py-3 text-sm text-[#205087]">
                        <FaUser className="w-4 h-4 mt-0.5 shrink-0" />
                        <div>
                            <p className="font-semibold">{selectedPatient.fullName || 'Paciente'}</p>
                            <p className="text-slate-600">
                                {selectedPatient.idType || 'CC'} {selectedPatient.idNumber}
                                {selectedPatient.email ? ` · ${selectedPatient.email}` : ''}
                            </p>
                        </div>
                    </div>

                    <PatientDoctorDocumentsTable
                        key={selectedPatient._id}
                        patientId={selectedPatient._id}
                        isDownload={true}
                    />
                </div>
            )}
        </div>
    );
};

export default ClinicPatientDocumentsSearch;
